import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';

export function NotFound() {
  return (
    <main className="flex min-h-screen flex-col items-center justify-center bg-cream px-6 text-center">
      <img
        src="/brand/cpn_leafseal.svg"
        alt=""
        aria-hidden="true"
        className="h-24 w-24 opacity-80"
      />
      <p className="mt-8 font-sans text-xs uppercase tracking-[0.2em] text-gold-dark">
        404
      </p>
      <h1 className="mt-3 font-display text-4xl text-navy">
        This page is <em>not on the map</em>.
      </h1>
      <p className="mt-4 max-w-md text-muted">
        The link might be stale, or the page hasn't been built yet. Head back to
        the home page and we'll find your way.
      </p>
      <Button asChild variant="gold" className="mt-8">
        <Link to="/">← Back to home</Link>
      </Button>
    </main>
  );
}
